import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { API_URL } from './utils/constants';

export const getUnreadMessagesCount = async () => {
  const apiPath = `project-email/get-unread-messages-count`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
  });

  const response = await axios(signedRequest);

  return response.data;
};
